import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"padding-top":"25px"},
  "txt-center": ""
}
const _hoisted_2 = { "txt-center": "" }
const _hoisted_3 = {
  "mtb-0": "",
  "txt-center": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_entStanding = _resolveComponent("entStanding")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_entStanding, {
        labelSelf: `You (${_ctx.$filters.capitalize(_ctx.userType)})`,
        standingSelf: _ctx.standing,
        size: "mini"
      }, null, 8, ["labelSelf", "standingSelf"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h2", {
        "m-tb-1": "",
        "txt-center": ""
      }, "Entrepreneurial Profile", -1)),
      _createElementVNode("p", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_link, {
          target: "_blank",
          href: _ctx.glossary
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("small", null, " Learn more", -1)
          ]))]),
          _: 1
        }, 8, ["href"])
      ])
    ])
  ], 64))
}